import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import HeaderInstitutions from "./HeaderInstitutions";

import axios from "axios";
import { api } from "../../../services/axios";

import LayersIcon from "@mui/icons-material/Layers";

import SimpleModal from "./modals/SimpleModal";

const InstitutionsCertificate = () => {
  const navigate = useNavigate();

  const [selectedProgramTypeIndexId, setSelectedProgramTypeIndexId] =
    useState("");
  const [selectedProgramIndexId, setSelectedProgramIndexId] = useState("");

  // const [programName, setProgramName] = useState([]);
  const [selectedExcelFile, setSelectedExcelFile] = useState(null);
  const [selectedZipFile, setSelectedZipFile] = useState(null);
  const [certificates, setCertificates] = useState([]);

  const [loading, setLoading] = useState(false);

  const [certificateUploadErrorMessage, setCertificateUploadErrorMessage] =
    useState("");
  const [isNetworkLoading, setIsNetworkLoading] = useState(false);
  const [registrationStatus, setRegistrationStatus] = useState(null);

  const [isSimpleModalOpen, setIsSimpleModalOpen] = useState(false);
  const [registrationError, setRegistrationErrorMessage] = useState("");
  const institution_name = localStorage.getItem("institution_name");

  const closeSimpleModal = () => {
    setIsSimpleModalOpen(false);
    clearFields();
    if (registrationStatus == "Upload Certificate Successful") {
      //navigate("/");
      clearFields();
      //onRequestClose();
    }
  };

  let token = localStorage.getItem("token");
  useEffect(() => {
    if (!token) {
      // Redirect to the home page if the token is null
      navigate("/");
    } else {
      // If the user is authenticated, call the handleData function
      // handleData();
      // getProgramsTypes();
    }
  }, [navigate]);

  const handleExcelFileChanged = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedExcelFile(file);
    } else {
      alert("No excel file selected");
    }
  };

  const handleZipFileChanged = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedZipFile(file);
      //alert('File selected: ' + file.name);
      //alert(file.name);
    } else {
      alert("No zip file selected");
    }
  };

  const clearFields = () => {
    setSelectedProgramTypeIndexId("");
    setSelectedProgramIndexId("");

    // const [programName, setProgramName] = useState([]);
    setSelectedExcelFile({});
    setSelectedZipFile({});

    setLoading(true);

    setCertificateUploadErrorMessage("");
    setIsNetworkLoading(false);
    setRegistrationStatus(null);
  };

  const downloadExcelFile = async () => {
    try {
      // Replace the file URL with the actual URL of your Excel file
      const excelFileUrl = "https://gacsstage.zaptrance.ng/sample_upload.xlsx";

      // Open the file URL in a new window or tab to initiate the download
      window.open(excelFileUrl, "_blank");
    } catch (error) {
      alert("Error downloading Excel file:" + error);
    }
  };

  // const handleCertificateUpload = async () => {
  //   if (!selectedExcelFile.name) {
  //     setCertificateUploadErrorMessage(
  //       "Please select an Excel file to upload."
  //     );
  //     return;
  //   }

  //   setCertificateUploadErrorMessage("");

  //   setIsNetworkLoading(true);

  //   try {
  //     const formData = new FormData();

  //     formData.append("institution_name", institution_name);
  //     formData.append("file", selectedExcelFile);

  //     const response = await api.post("/certificates/generate", formData, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });

  //     console.log("Response from server:", response);
  //     setIsNetworkLoading(false);
  //   } catch (err) {
  //     console.error(err);
  //     setCertificateUploadErrorMessage("Error preparing files for upload.");
  //     setIsNetworkLoading(false);
  //     return;
  //   }
  // };

  async function handleCertificateUpload() {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("institution_name", institution_name);
      formData.append("file", selectedExcelFile);

      const res = await api.post("/certificates/generate", formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCertificates(res.data.items); // render table
      setLoading(false);
    } catch (err) {
      setLoading(false);

      console.error("Download failed", err);
    }
  }

  return (
    <div className="content flex-grow">
      <div className="inner-content">
        <HeaderInstitutions />
        <div className="p-4" style={{ backgroundColor: "#F6F7FB" }}>
          <div className="text-black p-4 flex  text-xl">
            <div>
              <LayersIcon className="mr-4" />
            </div>
            Certificate
          </div>
          <div className="flex justify-between">
            <div
              className="rounded-lg p-4 flex-1 m-2 flex-col text-black"
              style={{ backgroundColor: "#ffffff" }}
            >
              <div className="flex flex-col justify-between my-2 pb-2">
                {/* <div className="text-black p-4 flex"><div><HistoryIcon className='mr-4'/></div>Upload Certificate</div> */}

                <div className="text-right">
                  <button
                    disabled={loading}
                    className="px-6 "
                    style={{
                      width: "200px",
                      backgroundColor: "#095918",
                      borderRadius: "8px",
                      padding: "10px 20px",
                      color: "white",
                      border: "none",
                    }}
                    onClick={handleCertificateUpload}
                  >
                    {loading ? "Uploading" : "Upload Certificate"}
                  </button>
                </div>
                <div style={{ display: "flex", justifyContent: "right" }}>
                  <p style={{ color: "#990000", fontSize: "12px" }}>
                    {certificateUploadErrorMessage}
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 ">
                <div
                  className="rounded-lg  flex-1 m-2 flex-col text-black"
                  //style={{ backgroundColor: '#DAD7FE' }}
                >
                  <div className="flex flex-col py-2">
                    <label>Excel File</label>

                    <div className="flex flex-col py-2 px-4">
                      <input
                        type="file"
                        id="paymentEvidenceInput"
                        accept=".xlsx, .xls"
                        onChange={handleExcelFileChanged}
                      />
                    </div>
                  </div>
                </div>
                {/* <div
                  className="rounded-lg  flex-1 m-2 flex-col text-black"
                  //style={{ backgroundColor: '#DAD7FE' }}
                >
                  <div className="flex flex-col py-2">
                    <label>Zip File</label>

                    <div className="flex flex-col py-2 px-4">
                      <input
                        type="file"
                        id="paymentEvidenceInput"
                        accept=".zip"
                        onChange={handleZipFileChanged}
                      />
                    </div>
                  </div>
                </div> */}
              </div>

              <div className="flex flex-col items-center my-2 pb-2 sm:flex-row sm:justify-between">
                <div className="pt-2">
                  <a
                    href="/Zaptrance_Sample_Sheet(2).xlsx"
                    download
                    style={{
                      width: "200px",
                      backgroundColor: "#095918",
                      borderRadius: "8px",
                      padding: "10px 20px",
                      color: "white",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    Download Sample Excel
                  </a>
                </div>

                {/* <div className="pt-2">
                                 <button className="px-6 " 
                                 style={{ 
                                   width: '200px', 
                                   backgroundColor: '#095918', 
                                   borderRadius: '8px', 
                                   padding: '10px 20px', 
                                   color: 'red', 
                                   border: 'none', 
                                   }}
                                   onClick={() => genrateQrCodeAndCertificate()}
                                   >
                                   Qr Code
                                   </button>
                                 </div> */}
              </div>
            </div>
          </div>

          <div>
            <CertificatesTable rows={certificates} />
          </div>

          <SimpleModal
            isOpen={isSimpleModalOpen}
            onRequestClose={closeSimpleModal}
            registrationStatus={registrationStatus}
            registrationError={registrationError}
            message="Certificate"
          />
        </div>
      </div>
    </div>
  );
};

function CertificatesTable({ rows }) {
  if (!rows?.length) {
    return <p>No certificates found.</p>;
  }

  return (
    <table className="min-w-full divide-y divide-gray-200 overflow-hidden rounded-lg shadow">
      <thead className="bg-[#095918] text-white">
        <tr>
          <th
            scope="col"
            className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider"
          >
            Full Name
          </th>
          <th
            scope="col"
            className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider"
          >
            Program
          </th>
          <th
            scope="col"
            className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider"
          >
            Certificate
          </th>
          <th
            scope="col"
            className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider"
          >
            CGPA
          </th>
          <th
            scope="col"
            className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider"
          >
            Verify URL
          </th>
          <th
            scope="col"
            className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider"
          >
            Issued
          </th>
          <th
            scope="col"
            className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider"
          >
            Download
          </th>
        </tr>
      </thead>
      <tbody className="bg-white divide-y divide-gray-100">
        {rows.map((row) => (
          <tr
            key={row.certificate_id}
            className="hover:bg-blue-50 transition-colors"
          >
            <td className="px-6 py-4 text-sm font-medium text-gray-900">
              {row.full_name}
            </td>
            <td className="px-6 py-4 text-sm text-gray-600">{row.program}</td>
            <td className="px-6 py-4 text-sm text-gray-600">
              {row.certificate}
            </td>
            <td className="px-6 py-4 text-sm text-gray-600">{row.cgpa}</td>
            <td className="px-6 py-4 text-sm">
              <a
                href={row.verify_url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 underline"
              >
                Verify
              </a>
            </td>
            <td className="px-6 py-4 text-sm text-gray-600">
              {new Date(row.created_at).toLocaleDateString()}
            </td>
            <td className="px-6 py-4 text-sm">
              {row.pdf_url ? (
                <a
                  href={row.pdf_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rounded bg-[#095918] px-3 py-1 text-white text-xs font-medium hover:bg-blue-700 transition-colors"
                >
                  Download
                </a>
              ) : (
                <a
                  href={`/certificates/download/${row.certificate_id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rounded bg-gray-600 px-3 py-1 text-white text-xs font-medium hover:bg-gray-700 transition-colors"
                >
                  Download
                </a>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default InstitutionsCertificate;
